/** The name of a chat in the list. The first chat is the alert channel of the cell. */
export const chatText = (id: string, index: number) => (index === 0 ? `Alert channel of the cell (${id})` : `Other channel (${id})`);

/** Why the settings cannot be saved, or null. The API checks the same rules. */
export function alertProblem(enabled: boolean, chat: string, rules: readonly string[]): string | null {
  if (!enabled) return null;
  if (!chat) return "Choose a channel before you turn the alerts on.";
  if (rules.length === 0) return "Choose at least one issue kind.";
  return null;
}
